import React, { useState, useRef, useEffect } from "react";

const CameraFallback = () => {
   const [stream, setStream] = useState(null);
   const [photo, setPhoto] = useState(null);
   const [error, setError] = useState(null);
   const videoRef = useRef(null);
   const canvasRef = useRef(null);

   useEffect(() => {
      // Start camera when component mounts
      startCamera();

      // Cleanup on unmount
      return () => {
         if (stream) {
            stream.getTracks().forEach((track) => track.stop());
         }
      };
   }, []);

   const startCamera = async () => {
      try {
         const mediaStream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: "environment" },
         });

         setStream(mediaStream);
         if (videoRef.current) {
            videoRef.current.srcObject = mediaStream;
         }
         setError(null);
      } catch (err) {
         setError("Unable to access camera. Please ensure you have granted camera permissions.");
         console.error("Camera error:", err);
      }
   };

   const takePhoto = () => {
      if (videoRef.current && canvasRef.current) {
         const video = videoRef.current;
         const canvas = canvasRef.current;
         const context = canvas.getContext("2d");

         // Set canvas dimensions to match video
         canvas.width = video.videoWidth;
         canvas.height = video.videoHeight;

         // Draw video frame to canvas
         context.drawImage(video, 0, 0, canvas.width, canvas.height);

         // Convert to data URL
         const dataUrl = canvas.toDataURL("image/jpeg");
         setPhoto(dataUrl);
      }
   };

   const retakePhoto = () => {
      setPhoto(null);
   };

   const savePhoto = () => {
      if (photo) {
         // Send photo back to parent window
         if (window.opener) {
            window.opener.postMessage(
               {
                  type: "camera-photo",
                  photo: photo,
               },
               "*"
            );
            window.close();
         } else {
            // If not opened as popup, download the photo
            const link = document.createElement("a");
            link.href = photo;
            link.download = "photo.jpg";
            link.click();
         }
      }
   };

   return (
      <div
         style={{
            minHeight: "100vh",
            backgroundColor: "#f5f5f5",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
         }}
      >
         <div
            style={{
               background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
               color: "white",
               padding: "20px",
               textAlign: "center",
            }}
         >
            <h1
               style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "600",
               }}
            >
               Camera Capture
            </h1>
         </div>

         <div
            style={{
               padding: "20px",
               maxWidth: "600px",
               margin: "0 auto",
            }}
         >
            {error && (
               <div
                  style={{
                     backgroundColor: "#fee",
                     border: "1px solid #fcc",
                     borderRadius: "8px",
                     padding: "20px",
                     textAlign: "center",
                     color: "#c00",
                  }}
               >
                  <p>{error}</p>
                  <button
                     onClick={startCamera}
                     style={{
                        padding: "10px 20px",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontWeight: "500",
                     }}
                  >
                     Try Again
                  </button>
               </div>
            )}

            {!photo && !error && (
               <div
                  style={{
                     position: "relative",
                     backgroundColor: "#000",
                     borderRadius: "8px",
                     overflow: "hidden",
                  }}
               >
                  <video
                     ref={videoRef}
                     autoPlay
                     playsInline
                     style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                     }}
                  />
                  <canvas ref={canvasRef} style={{ display: "none" }} />

                  <div
                     style={{
                        position: "absolute",
                        bottom: "20px",
                        left: "50%",
                        transform: "translateX(-50%)",
                     }}
                  >
                     <button
                        onClick={takePhoto}
                        style={{
                           background: "none",
                           border: "none",
                           cursor: "pointer",
                           padding: "10px",
                        }}
                     >
                        <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                           <circle cx="30" cy="30" r="28" stroke="white" strokeWidth="4" />
                           <circle cx="30" cy="30" r="22" fill="white" />
                        </svg>
                     </button>
                  </div>
               </div>
            )}

            {photo && (
               <div
                  style={{
                     textAlign: "center",
                  }}
               >
                  <img
                     src={photo}
                     alt="Captured"
                     style={{
                        width: "100%",
                        maxWidth: "500px",
                        height: "auto",
                        borderRadius: "8px",
                        marginBottom: "20px",
                     }}
                  />

                  <div
                     style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                     }}
                  >
                     <button
                        onClick={retakePhoto}
                        style={{
                           padding: "10px 20px",
                           borderRadius: "6px",
                           border: "1px solid #ddd",
                           cursor: "pointer",
                           fontSize: "16px",
                           fontWeight: "500",
                           backgroundColor: "white",
                           color: "#333",
                        }}
                     >
                        Retake
                     </button>
                     <button
                        onClick={savePhoto}
                        style={{
                           padding: "10px 20px",
                           borderRadius: "6px",
                           border: "none",
                           cursor: "pointer",
                           fontSize: "16px",
                           fontWeight: "500",
                           backgroundColor: "#667eea",
                           color: "white",
                        }}
                     >
                        Use Photo
                     </button>
                  </div>
               </div>
            )}
         </div>
      </div>
   );
};

export default CameraFallback;
